<template>
  <v-card>
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>add</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Invest Details</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%">
      <div v-for="prop in displayProps">
        <strong>{{ prop.title }}</strong
        ><br />
        <p>{{ item[prop.key] }}</p>
      </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      investProps: [
        { title: "Invest Date", key: "payment_date" },
        { title: "Investor Name", key: "investors___name" },
        { title: "Amount", key: "amount" },
        { title: "Payment Method", key: "method" },
        { title: "Cheque Issue Date", key: "check_date" },
        { title: "Cheque Number", key: "check_number" },
        { title: "Bank Name", key: "check_bank_name" },
        { title: "Bank Branch", key: "check_bank_branch" },
        { title: "Notes", key: "notes" },
      ],
    };
  },
  computed: {
    displayProps() {
      if (this.item && this.item.method != "cheque") {
        return this.investProps.filter(
          (r) =>
            ![
              "check_date",
              "check_number",
              "check_bank_name",
              "check_bank_branch",
            ].includes(r.key)
        );
      }

      return this.investProps;
    },
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
  },
  mounted() {},
  created() {},
};
</script>
